import React, { useState, useEffect } from 'react';
import './ChatPreview.css';

const ChatPreview = () => {
  const [resetKey, setResetKey] = useState(0);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setResetKey(prevKey => prevKey + 1);
    }, 4000);
    
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="chat-preview-container">
      <div className="chat-preview-header">
        <span>Nur Al Huda</span>
      </div>
      <div className="chat-preview-messages">
        <div key={`user-${resetKey}`} className="chat-message user">
          <p>How can I navigate Muslim identity in today's world?</p>
        </div>
        <div key={`assistant-${resetKey}`} className="chat-message assistant">
          <p>Islam teaches us that our identity is rooted in our connection with Allah and our actions. Focus on developing strong character, practicing regular worship, and engaging positively with your community while staying true to Islamic principles.</p>
        </div>
        <div className="chat-input">
          <input type="text" placeholder="Type your message..." disabled />
          <button className="send-button" disabled>
            <svg viewBox="0 0 24 24" className="send-icon">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatPreview; 